import { Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import LedgerAccountSelector from "@/components/pieces/products/LedgerAccountSelector";

export default function CreditsConfirmation({
  ledgerAccounts,
  ledgerAccountId,
  setLedgerAccountId,
  orderCreditTotal,
  allowBuyCredits,
}) {
  const ledgerAccount =
    ledgerAccountId && ledgerAccounts?.find((a) => a.id === ledgerAccountId);

  return (
    <>
      <Box fontSize={22} fontWeight={600} mb={3}>
        Checkout Using Credits
      </Box>
      <LedgerAccountSelector
        ledgerAccounts={ledgerAccounts}
        ledgerAccountId={ledgerAccountId}
        onSelectAccountId={setLedgerAccountId}
      />
      {(ledgerAccount?.balance || 0) < orderCreditTotal ? (
        <Box mt={3}>
          <Callout intent="warning">
            <Box fontWeight={500}>Not enough credits</Box>
            <Box mt={1}>
              Your account doesn't have enough credits to complete this order.{" "}
              {ledgerAccount?.balance > 0
                ? `Unfortunately, we don't support partial payments using credits. `
                : null}{" "}
              {allowBuyCredits
                ? "Please choose a different payment method or use a gift code to add credits to your account."
                : "Please contact your workspace administrator for additional credits."}
            </Box>
          </Callout>
        </Box>
      ) : null}
    </>
  );
}
